import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

export const StorageKey = {
  THEME: 'theme',
  ACTIVE_SCHOOL_ID: 'activeSchoolId',
  SCHOOL_LEVELS: 'schoolLevels',
  ACADEMIC_YEARS: 'academicYears',
  USER_PREFERENCES: 'userPreferences',
} as const;

export type StorageKeyType = (typeof StorageKey)[keyof typeof StorageKey];

@Injectable({
  providedIn: 'root',
})
export class LonniyireLocalstorageService {
  private readonly document = inject(DOCUMENT);

  getItem(key: StorageKeyType): unknown | null {
    const value = this.storage()?.getItem(key);
    if (value === null || value === undefined) {
      return null;
    }

    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }

  setItem(key: StorageKeyType, value: unknown): void {
    this.storage()?.setItem(key, JSON.stringify(value));
  }

  removeItem(key: StorageKeyType): void {
    this.storage()?.removeItem(key);
  }

  clear(): void {
    this.storage()?.clear();
  }

  private storage(): Storage | null {
    try {
      return this.document.defaultView?.localStorage ?? null;
    } catch {
      return null;
    }
  }
}
